import { TopBar } from '@/components/common/top-bar';
import { useRoute } from '@/hooks/use-route';

export const FermentationTopBar = () => {
  const { routeToFermentationTracking } = useRoute();

  return <TopBar onBack={() => routeToFermentationTracking()}></TopBar>;
};
